import Tabs from "../components/tabs";
import Flickity from "flickity";
import Headline from "../components/headline-rotate";
import isAutoplaySupported from "../util/isAutoplaySupported";

export default {
    init() {
    },
    finalize() {

        var tabs = new Tabs(),
            isChrome = !!window.chrome && !!window.chrome.webstore,
            player = document.getElementById('player');
        window.video_playing = false;

		if(player !== null) {
			player.addEventListener('playing',function(){
				console.log('playing');
				window.video_playing = true;
			});

			setTimeout(function(){
				isAutoplaySupported(supported => {
					if (isChrome || window.video_playing || supported) {
                        console.log('autoplay is supported');
						player.addEventListener('ended',function(){

							setTimeout(function(){

								var swipeEl = document.querySelector('.to-swipe');
								var swipeInnerEl = document.querySelector('.to-swipe-inner');
                                if ( swipeEl && swipeInnerEl ) {
                                    swipeEl.classList.add('swipe');
                                    swipeEl.classList.add('swipe--in');
                                    swipeEl.classList.remove('to-swipe');

                                    swipeInnerEl.classList.add('swipe__inner');
                                    swipeInnerEl.classList.remove('to-swipe-inner');
                                }

							},500);

						},false);
					}
					else {
                        console.log('autoplay is supported, hide video');
						document.querySelector('.banner__video').style.display = "none";

						var swipeEl = document.querySelector('.to-swipe');
						var swipeInnerEl = document.querySelector('.to-swipe-inner');
                        if ( swipeEl && swipeInnerEl ) {
    						swipeEl.classList.add('swipe');
    						swipeEl.classList.add('swipe--in');
    						swipeEl.classList.remove('to-swipe');

    						swipeInnerEl.classList.add('swipe__inner');
    						swipeInnerEl.classList.remove('to-swipe-inner');
                        }
					}
				})
			},500);

        }
        else {
            setTimeout(function(){
                var swipeEl = document.querySelector('.to-swipe');
                var swipeInnerEl = document.querySelector('.to-swipe-inner');
                if ( swipeEl && swipeInnerEl ) {
                    swipeEl.classList.add('swipe');
                    swipeEl.classList.add('swipe--in');
                    swipeEl.classList.remove('to-swipe');

                    swipeInnerEl.classList.add('swipe__inner');
                    swipeInnerEl.classList.remove('to-swipe-inner');
                }
			},500);
        }

        tabs.autoPlay('home__tabs');

        // NUTRITIONIST LOAD

        var nutritionistImages = document.querySelectorAll('.nutritionist img');
        var nutritionistImgs = Array();
        var loaded = 0;

        for (var i = 0; i < nutritionistImages.length; i++) {
            nutritionistImgs.push(new Image());

            nutritionistImgs[i].onload = (function (value) {
                return function () {
                    loaded++;

                    if (loaded >= nutritionistImages.length) {

                        var carousel = new Flickity(".nutritionist__carousel", {
                            groupCells: true,
                            pageDots: false,
                            selectedAttraction: 0.1,
                            imagesLoaded: true,
                            friction: 1,
                            arrowShape: 'M 0,50 L 20,30 L 20,45 L 100,45 L 100,55 L 20,55 L 20,70 Z'
                        });

                        jQuery('.nutritionist').css('height', '100%');

                    }
                };
            })(i);

            nutritionistImgs[i].src = nutritionistImages[i].getAttribute("data-src");
        }

        jQuery(document).ready(function () {
            var headline = new Headline(jQuery('.cd-headline'),2500);
        });

    }
};



// WEBPACK FOOTER //
// ./js/routes/home.js